import { fromJS } from 'immutable';
import {
  AUTHENTICATE,
  AUTHENTICATE_DONE,
  AUTHENTICATE_FAIL,
  USER_LOADED,
  LOAD_CACHED_USER_ATTEMPTED,
  LOGOUT
} from './constants';

export const initialState = fromJS({
  isSignedIn: false,
  isAuthenticating: false,
  authenticateError: null,
  loadCachedUserAttempted: null,
  reauthenticate: false,
  user: null
});

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case AUTHENTICATE: {
      return state.set('isAuthenticating', true).set('authenticateError', '');
    }

    case AUTHENTICATE_DONE: {
      return state
        .set('isAuthenticating', false)
        .set('authenticateError', null);
    }

    case AUTHENTICATE_FAIL: {
      return state
        .set('authenticateError', fromJS(payload))
        .set('isAuthenticating', false);
    }

    case LOAD_CACHED_USER_ATTEMPTED: {
      return state.set('loadCachedUserAttempted', true);
    }

    case USER_LOADED: {
      return state.set('user', fromJS(payload)).set('isSignedIn', true);
    }

    case LOGOUT:
      return initialState.set('reauthenticate', true);

    default:
      return state;
  }
}
